import { RouteProp, useRoute } from "@react-navigation/native";
import { Button, Card, Divider, Text } from "@ui-kitten/components";
import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { ScreenLayout } from "../common/layout/ScreenLayout";
import { Cell, RowHeader, Table, TBody, Tr } from "../common/table";
import { MixerIngredientForm } from "../mixer/mixer-flavor/MixeIngredientForm";
import { MixerSlider } from "../mixer/MixerSlider";
import { useMixer } from "../mixer/useMixer";
import { BatchStackParamList } from "../navigation";

export const BatchCreateScreen = () => {
    const { params } = useRoute<RouteProp<BatchStackParamList>>();

    const {
        baseNicStrength,
        setBaseNicStrength,
        baseVg,
        setBaseVg,
        targetNicStrength,
        setTargetNicStrength,
        targetVg,
        setTargetVg,
        batchSize,
        setBatchSize,
        result,
        ingredientFormValues,
        onAddIngredient,
        onIngredientChange,
        onRemoveIngredient,
        saveBatch,
        isValid,
        isSaving,
        //@ts-ignore
    } = useMixer(params?.recipeId);

    const renderIngredientForms = () => {
        return ingredientFormValues.map((ingredientFormValue) => {
            return (
                <View style={{ marginBottom: 16 }} key={ingredientFormValue._id}>
                    <MixerIngredientForm
                        values={ingredientFormValue}
                        onChange={(values) => onIngredientChange(values)}
                        onRemove={() => onRemoveIngredient(ingredientFormValue._id)}
                    />
                    <Divider style={{ marginTop: 8 }} />
                </View>
            );
        });
    };

    return (
        <View style={{ flex: 1 }}>
            <ScreenLayout scroll={true}>
                <View style={{ flex: 1 }}>
                    <View style={styles.section}>
                        <Text category="h6" style={styles.sectionTitle}>
                            Base
                        </Text>
                        <View style={styles.sliderContainer}>
                            <Text style={styles.sliderTitle}>Nicotine Strenght</Text>
                            <MixerSlider
                                unit="mg/ml"
                                max={200}
                                value={baseNicStrength}
                                onValueChange={setBaseNicStrength}
                            />
                        </View>
                        <View style={styles.sliderContainer}>
                            <Text style={styles.sliderTitle}>VG</Text>
                            <MixerSlider max={100} value={baseVg} onValueChange={setBaseVg} />
                        </View>
                    </View>
                    <View style={styles.section}>
                        <Text category="h6" style={styles.sectionTitle}>
                            Target
                        </Text>

                        <View style={styles.sliderContainer}>
                            <Text style={styles.sliderTitle}>Nicotine Strenght</Text>
                            <MixerSlider
                                max={30}
                                unit="mg"
                                value={targetNicStrength}
                                onValueChange={setTargetNicStrength}
                            />
                        </View>
                        <View style={styles.sliderContainer}>
                            <Text style={styles.sliderTitle}>VG</Text>
                            <MixerSlider max={100} value={targetVg} onValueChange={setTargetVg} />
                        </View>
                        <View style={styles.sliderContainer}>
                            <Text style={styles.sliderTitle}>Batch Size</Text>
                            <MixerSlider max={200} unit="ml" value={batchSize} onValueChange={setBatchSize} />
                        </View>
                    </View>
                    <View style={styles.section}>
                        <ScrollView style={{ flex: 1 }}>
                            <Text category="h6" style={styles.sectionTitle}>
                                Ingredients
                            </Text>

                            <Divider style={{ marginTop: 8 }} />
                            <View style={{ marginBottom: 32 }}>{renderIngredientForms()}</View>
                            <View style={{ height: 56, alignItems: "center", justifyContent: "center" }}>
                                <Button size="small" onPress={onAddIngredient}>
                                    + Add Ingredient
                                </Button>
                            </View>
                        </ScrollView>
                    </View>
                    <View style={styles.section}>
                        <Text category="h6" style={styles.sectionTitle}>
                            Result
                        </Text>
                        <Card style={{ overflow: "visible" }}>{!!result && <Table result={result} />}</Card>
                        {!!result && (
                            <View style={{ paddingLeft: 24, paddingRight: 24 }}>
                                <TBody>
                                    <Tr>
                                        <RowHeader>SUM</RowHeader>
                                        <Cell>{result.ml.sum}</Cell>
                                        <Cell>{result.g.sum}</Cell>
                                    </Tr>
                                </TBody>
                            </View>
                        )}
                    </View>
                </View>
            </ScreenLayout>
            <View>
                <Card>
                    <Button disabled={!isValid} onPress={saveBatch}>
                        {isSaving ? "Creating..." : "Create Batch"}
                    </Button>
                </Card>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    section: {
        marginBottom: 32,
    },
    sectionTitle: {
        fontWeight: "400",
    },
    sliderContainer: {
        marginBottom: 16,
    },
    sliderTitle: {
        fontWeight: "400",
        textAlign: "center",
        marginBottom: 8,
    },
});
